// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"2dbbbc3b","884":"bd07bfad"}[chunkId] + ".chunk.js";
};